import { Location } from '../types';

export function getLocationHref(location: Location) {
  const apple = navigator.platform.indexOf('iPhone') !== -1 || navigator.platform.indexOf('iPad') !== -1 || navigator.platform.indexOf('iPod') !== -1;

  return `${apple ? 'maps' : 'https'}://maps.google.com/?saddr=My%20Location&daddr=${encodeURIComponent(location.address.street)}`;
}
